import React from "react";

import { DatasheetFieldComponentGetDto } from "@common/dto/datasheet/field-component/get-dto";
import { IDatasheetResultElement } from "@modules/datasheets/components/result/types/datasheet-element";
import { getCommonFieldBasedElementParams, useDatasheetElementController } from "@modules/datasheets/components/result/controllers/datasheet-element";
import { trDts } from "@modules/datasheets/utils/i18n";
import { TableFieldDataItem } from "./table-field.types";
import { DatasheetFieldComponentOriginFieldGetDto } from "@common/dto/datasheet/field-component/origin-field-dto";
import { DatasheetTableFieldValueDataItem } from "@common/dto/datasheet/field-component/table-field";

export type TableFieldProps = IDatasheetResultElement<DatasheetFieldComponentGetDto>;

export const useTableFieldController = (props: TableFieldProps) => {
  const { datasheetElement, onChange } = props;
  const [selectedItemId, setSelectedItemId] = React.useState<string | undefined>();

  const { 
    headingSizeDependencies, 
    headingPlacedHorizontally, 
    headingPosition 
  } = getCommonFieldBasedElementParams(props);

  const baseDatasheetElementController = useDatasheetElementController(
    props,
    { headingSizeDependencies }
  );

  const currentValue: Array<DatasheetTableFieldValueDataItem> = [];

  const updateField = React.useCallback((field: Partial<DatasheetFieldComponentOriginFieldGetDto>) => {
    onChange(datasheetElement.id, {
      ...datasheetElement,
      original: {
        ...datasheetElement.original,
        field: {
          ...datasheetElement.original.field,
          ...field,
        },
      },
    });
  }, [onChange, datasheetElement]);

  const handleResizeColumn = React.useCallback(({ field }: { field: DatasheetFieldComponentOriginFieldGetDto }) => {
    updateField({
      subfields: datasheetElement.original.field.subfields?.map((subField) =>
        subField.fieldid === field.fieldid ? field : subField
      ),
    });
  }, [updateField, datasheetElement]);

  const handleRowClick = React.useCallback((item: TableFieldDataItem) => {
    setSelectedItemId(item.id);
  }, []);

  const handleItemAdd = React.useCallback(() => {
    const newItem = datasheetElement.original.field.subfields?.reduce<TableFieldDataItem>((acc, subfield) => {
      acc[subfield.fieldname] = "";
      return acc;
    }, { id: `${Date.now()}` });

    if (newItem) {
      // updateField({
      //   value: [
      //     ...(currentValue || []),
      //     newItem,
      //   ],
      // });
    }
  }, [updateField, currentValue, datasheetElement]);

  const handleItemCopy = React.useCallback(() => {
    if (selectedItemId) {
      const selectedItem = currentValue?.find((item) => item.id === selectedItemId);

      if (selectedItem) {
        // updateField({
        //   value: [
        //     ...(currentValue || []),
        //     { ...selectedItem, id: `${Date.now()}` },
        //   ],
        // });
      }
    }
  }, [updateField, selectedItemId, currentValue]);

  const handleItemDelete = React.useCallback(() => {
    if (selectedItemId) {
      // updateField({
      //   value: (currentValue || []).filter((item) => item.id !== selectedItemId),
      // });

      setSelectedItemId(undefined);
    }
  }, [updateField, selectedItemId, currentValue]);

  const footerActions = [
    {
      label: trDts('Add'),
      onClick: handleItemAdd,
    },
    {
      disabled: !selectedItemId,
      label: trDts('Copy'),
      onClick: handleItemCopy,
    },
    {
      disabled: !selectedItemId,
      label: trDts('Delete'),
      onClick: handleItemDelete,
    }
  ];

  return {
    currentValue,
    handleRowClick,
    footerActions,
    headingPlacedHorizontally,
    headingPosition,
    handleResizeColumn,
    selectedItemId,
    ...baseDatasheetElementController,
  };
};
